<template>
  <div style="background: #f2f2f6; height: 100%">
    <el-form size="mini" label-width="100px" class="demo-form-inline">
      <el-row>
        <el-col :span="10" style="text-align:left">
      <el-form-item :label="$t('base.timeInterval')">
    <el-date-picker
v-model="where.betweendate"
type="datetimerange"
:range-separator="$t('base.to')"
:start-placeholder="$t('base.beginTime')"
size="mini"
value-format="yyyy-MM-dd HH:mm:ss"
:default-time="['00:00:00','23:59:59']"
:end-placeholder="$t('base.endTime')">
</el-date-picker>
</el-form-item>
</el-col>
<el-col :span="8">
<el-form-item :label="$t('device.heatpumpSelect')">
<el-select
         size="mini"
         v-model="where.deviceid"
       >
         <el-option
           v-for="item in heatpump"
           :key="item.innerid"
           :label="item.name"
           :value="item.innerid"
           v-if="item.subdevs<=($store.state.slavenum+1)"
         >
         </el-option>
       </el-select>
</el-form-item>
</el-col>
<el-col :span="6" style="text-align:right">
  <el-button size="small" type="primary" @click="searchError()">{{$t("base.search")}}</el-button>
          <el-divider direction="vertical"></el-divider>
         <el-button :title="$t('base.export')"  type="success"  size="small" icon="el-icon-upload2" onclick="download('errortable','Heatpump Error Data')"></el-button>
</el-col>
</el-row>
</el-form>
        <el-table
          id="errortable"
          :data="tabledata"
          v-loading="loading"
          ref="table"
          border
          stripe
          style="width: 100%; border-radius: 0 0 10px 10px;font-size:12px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }">
          <template slot="empty">
                 <div>{{$t("device.noErrorData")}}
              </div>
             </template>　
           <el-table-column
            type="index"
            :index="indexMethod"
            width="75">
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('device.deviceName')"  width="150">
          </el-table-column>

          <el-table-column
            prop="errmsg"
            :label="$t('device.errorMsg')"
            size="small"
            >
            <template slot-scope="scope">
             <span> {{  $i18n.locale=='en'?(scope.row.errmsg_en||scope.row.errmsg): scope.row.errmsg}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdtime"
            :label="$t('device.errorTime')"
          >
          </el-table-column>
          <el-table-column
            prop="reset"
            :label="$t('device.resetTime')"
          >
          </el-table-column>
          <el-table-column
            :label="$t('base.opt')"
            v-if="user.logintype==1"
          >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="del(scope.row)">{{$t('base.del')}}</el-button>
          </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 10px;margin-bottom:10px"
        >
        </el-pagination>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'ErrorPage',
  data () {
    return {
      tabledata: [],
      user:{},
      loading: true,
      where:{
        projectid:this.$store.state.project.projectid,
        deviceid:'',
        betweendate: []
      },
      pageset: {
        size: 10,
        index: 1
      },
      totalsize: 0
    }
  },
  computed: {
    heatpump () {
      return this.$store.state.devicelist.filter(d => { return d.type == 'heatpump' })
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user=JSON.parse(customer)
      if(this.$store.state.project.projectid){
        self.searchError()
      }else{
        setTimeout(()=>{
          self.searchError()
        },4000)
      }
        
    } else {
      this.$message({
        message: this.$t("base.noSession"),
        type: 'error'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    searchError () {
      if(this.user.logintype==2){
        let dpermission= window.localStorage.getItem('dpermission')
        if(dpermission){
          dpermission=JSON.parse(dpermission)
          if(dpermission&&dpermission.heatpump&&dpermission.heatpump.errorhide){
            return
          }
        }
      }

      this.where.projectid=this.$store.state.project.projectid
      var self = this
      self.loading = true
      Vue.axios
        .post('/equipment/history/error/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
          self.loading = false
        })
      Vue.axios
        .post('/equipment/history/error/list/count', {
          where: this.where,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchError()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchError()
    },
    del(row){
      this.$confirm(
       this.$t('device.confirmDeleteError')+'？',
       this.$t("base.info"),
        {
          confirmButtonText: this.$t("base.confirm"),
          cancelButtonText: this.$t("base.cancel"),
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/equipment/history/error/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: self.$t("base.delSuccess")
                })
                self.searchError()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || this.$t("base.systemError"),
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Devices/HistoryError.vue